/**
 * W1-11a (app-registry-keymap): `keymap: KeymapService` (contract app/registry/types.ts, ARCHITECTURE.md §6.3).
 *
 * The app-wide keymap: the registry's modules' preset bindings, the user's overrides (`remove: true` included),
 * the Alt-free variant and the macOS transform, with settings.keyboard as the single source of truth and labels in
 * the user's keyboard layout. Implementation, audit and helpers: keymapCore.ts.
 */

import { settings } from '../settings/settingsService';
import { detectOs } from './chords';
import { createKeymapService, type AppKeymap } from './keymapCore';
import { layoutLabels } from './layoutLabels';
import { registry } from './registry';

export {
  assembleKeymap,
  auditKeymaps,
  createKeymapService,
  KEYMAP_PRESETS,
  transformPresetChord,
  type AppKeymap,
  type KeymapEntry,
  type KeymapIssue,
} from './keymapCore';

export const keymap: AppKeymap = createKeymapService({
  modules: () => registry.modules,
  command: (id) => registry.command(id),
  whenAtomNames: () => registry.whenAtomNames(),
  settings,
  os: detectOs(),
  labels: layoutLabels,
  onSourcesChange: (cb) => registry.onChange(cb),
});
